/**
 *  Editor component for promotion of sales channel content
 *  Author: Chris
 *  CreatedAt: 2021-03-23
 */

import React from 'react';

import { useDispatch } from 'react-redux';
import { useParams /*useLocation,*/ } from 'react-router-dom';
import { dispatch } from 'src/store';

import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from '../../../constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import { FeaturedProduct } from './FeaturedProduct';

// import { Preview } from '@/src/constrains';
import RouteBlock from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/RouteBlock';
import { convertDataFromReduxToServer } from './apiUtil';

import {
  fetchContentPromotion,
  getHasModified,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  onShiftItems,
  resetData,
  submitContentPromotion,
  validation,
} from './redux';
//import { store } from 'src/store';
import CloneBtn from 'src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/CloneButton';
//import { IPromotion } from '@/src/types/common/SalesChannel';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
import PopUpWindow from './PopUpWindow/PopUpWindow';

import { LinkModuleType } from '@/src/types/common/linkType';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from './style.module.less';

interface IParams {
  contentUuid: string;
  saleChannelUuid: string;
}

const SalesChannelEditorPromotion = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    loaded,
    isOnPrimaryLanguage,
  } = props;

  const _d = useDispatch();

  const _params: IParams = useParams();
  const { contentUuid, saleChannelUuid } = _params;

  React.useEffect(() => {
    return () => {
      _d(resetData());
    };
  }, []);

  return (
    <React.Fragment>
      <RouteBlock getHasModified={getHasModified} />
      <PageWrapper
        hideRightPart
        withoutCollapse
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName,
          onDiscard,
          onGoBack,
        }}
        leftChild={
          loaded ? (
            <RightConfigWrapper
              wrapperClassName={styles.container}
              title={getI18n('general.sider.promotion')}
              elements={[
                {
                  key: 'moduleContent',
                  body: (
                    <Combination
                      contentUuid={contentUuid}
                      saleChannelUuid={saleChannelUuid}
                      isPrimary={isOnPrimaryLanguage}
                    />
                  ),
                },
              ]}
            />
          ) : null
        }
      />
    </React.Fragment>
  );
};

const Combination = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { isPrimary } = props;
  return (
    <div>
      {!isPrimary && (
        <CloneBtn
          buttonText={getI18n(
            'salesChannelContent.index.clonefromPrimaryLanguageContent',
          )}
        />
      )}
      <FeaturedProduct
        withoutCollapse
        isPrimary={isPrimary}
        salesChannelContentUuid={props.contentUuid}
        salesChannelUuid={props.saleChannelUuid}
      />
      <div className={styles.list}>
        <PopUpWindow
          withoutCollapse
          linkSet={{
            scopeVariables: {
              SalesChannelContent: props.contentUuid,
            },
            linkTypeFilter: [
              LinkModuleType.LinkLibrary,
              LinkModuleType.Collection,
              LinkModuleType.ContentPage,
              LinkModuleType.None,
              LinkModuleType.Product,
              LinkModuleType.HomePage,
              LinkModuleType.AllProducts,
            ],
          }}
        />
      </div>
    </div>
  );
};

export default BasicPageHOC(SalesChannelEditorPromotion, {
  getState,
  convertDataFromReduxToServer,
  beforeSubmitNeedDispatch: onShiftItems,
  submit: submitContentPromotion,
  getHasModified,
  getSalesChannel: getSalesChannel,
  getSalesChannelName: getSalesChannelName,
  validation,
  getLoaded,
  queryData: (params, qParams) => {
    const { contentUuid } = params;

    dispatch(
      fetchContentPromotion({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
